// extracted by css-extract-rspack-plugin
export default {"root":"rztlCG","card":"QoljfK","logoRow":"YoYDqZ","logo":"T3jGz1","row":"apUCWL","spinnerRow":"Zqmkvq","message":"qym0ri","spin":"w7CW2z"};